<script lang="ts">
import { onMount } from "svelte";
import { Button, Icon } from "sveltestrap";
import { navigate } from "svelte-navigator";
import type { Car } from "../Model/Car";
import { carService } from "../services";
import ChronoTime from "./ChronoTime.svelte";
import ClientBar from "./ClientBar.svelte";
import type { Client } from "../Model/Client";
import { getCurrentUser } from "../services/session";

let cars: Car[]; 
let client: Client;
let viewCarsList:boolean = false;

onMount(() => {
  client = getCurrentUser()
  cars = carService.getAllCars(client.id.value);

  if (!cars) {
    navigate('/parking')
  }

  viewCarsList = true
})



</script>

<style lang="scss">

  .control-html{
    position: relative;
    width: 100vw;
    display: flex;
    align-items: center;
    flex-direction: column;
    max-width: 450px;
    margin: auto;
    background-color: #BAD9FF;
  }

  .card{
    margin-bottom: 10px;

    .card-body{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      :global(#icon-to-park){
        font-size: 1.5rem;
      }
    }
  }

  .body-html {
    position: relative;
    height: 100%;
    padding-bottom: 40px;
    max-width: 360px;
    min-height: 200px;
    width: 100%;
    margin: auto;
  }

  .content-img{
    width: 100%;
    margin: 35px 0 35px 0;

    img{
      width: 30%;
      align-items: center;
      vertical-align: middle;
      max-width: 400px;
      align-self: center;
    }
  }

  :global(#button-next-car){
    width: 85%;
    margin: auto;
    display: block;
    background-color: #34A853;
    border-color: #34A853;
    min-height: 45px;
    font-size: 20px;
    font-weight: bold;
    border-radius: 10px;
  }

  .content-html{
    width: 85%;
    background-color: #fff;
    padding: 15px;
    border-radius: 10px;
    margin: auto;
    min-height: 300px;

    .tittle-car{
      font-weight: 500;
      font-size: 20px;
      color: #707070;
      margin-left: 10px;
    }

  }

</style>

<div class="control-html">
  <ClientBar />
  <div class="content-img text-center">
    <img alt="" src="/img/car_icon.png"> 
  </div>
  <div class="body-html">
    <div class="content-html">
      <div class="mb-3">
        <span class="tittle-car">Listado de Vehículos</span>
      </div>
        {#if viewCarsList}
          {#each cars as car}
            <div class="card" on:click={() => navigate('parking/' + car.plate)}>
              <div class="card-body">
                <span class="tittle-car">{car.plate}</span>
                <div class="tittle-car">
                  <Icon id="icon-to-park" name="chevron-double-right"/>
                </div>
              </div>
            </div>
          {/each}
        {/if}

    </div>
    <div class="text-center mt-3">
      <Button id="button-next-car" type="button" color="primary" on:click={() => {navigate('/parking')}}>Añadir otro vehículo</Button>
    </div>
  </div>
</div>